"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_apexcharts_1 = __importDefault(require("react-apexcharts"));
const DateRangePickerFr_1 = __importDefault(require("../../Shared/DateRangePickerFr"));
function LineChart({ data, dates, setDates, }) {
    const [state, setState] = (0, react_1.useState)({
        series: [{ name: "Utilisateurs", data: [] }],
        options: {
            chart: {
                height: 350,
                type: "line",
                toolbar: { show: false },
                zoom: { enabled: false },
            },
            dataLabels: { enabled: false },
            stroke: { curve: "smooth" },
            xaxis: { categories: [] },
            tooltip: { x: { format: "dd/MM/yy HH:mm" } },
            fill: { colors: ["#FF9800"] },
        },
    });
    console.log("data dashboard", data);
    (0, react_1.useEffect)(() => {
        if (data && data.length > 0) {
            setState((prev) => (Object.assign(Object.assign({}, prev), { series: [
                    {
                        name: "Utilisateurs",
                        data: data.map((item) => item.count),
                    },
                ], options: Object.assign(Object.assign({}, prev.options), { xaxis: {
                        categories: data.map((item) => {
                            const [day, month, year] = item.day.split(".");
                            return new Date(Number(year), Number(month) - 1, Number(day))
                                .toLocaleString("fr-FR", {
                                weekday: "short", // 'lun.', 'mar.', etc.
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            })
                                .replace(/^\w/, (c) => c.toUpperCase());
                        }),
                    } }) })));
        }
    }, [data]);
    return (react_1.default.createElement("div", { className: "chart-item-container" },
        react_1.default.createElement("div", { className: "content-chart-title mb-4" },
            react_1.default.createElement("h2", { className: "chart-item-admin-title mb-0" }, "Utilisateurs actifs"),
            react_1.default.createElement("div", { className: "select-form-group position-relative custom" },
                react_1.default.createElement(DateRangePickerFr_1.default, { value: dates, onChange: (range) => setDates(range), onClear: () => setDates({
                        startDate: null,
                        endDate: null,
                        key: "selection",
                    }) }))),
        react_1.default.createElement("div", { id: "chart" },
            react_1.default.createElement(react_apexcharts_1.default, { options: state.options, series: state.series, type: "line", height: 450 }))));
}
exports.default = LineChart;
